import firebase from "firebase/app";

import { BaseModel } from "@/models/base/BaseModel";
import {
  RecurringEventsType,
  RecurringRepeatOnDay,
  RecurringRepeatOnNumber,
  RecurringRepeatType,
} from '@/enums/RecurringEventsType';

export class Calendar extends BaseModel {
  channelId: string;
  createdByResidentId: string;
  end: Date | null | firebase.firestore.Timestamp;
  familyCallInvitees: string[];
  familyGoing: string[];
  familyNotGoing: string[];
  familyCallInviteesIds: string[];
  createdByFamilyUserId: string;
  going: string[];
  goingDetails: any;
  invitees: string[];
  location: string;
  name: string;
  notgoing: string[];
  start: Date | null | firebase.firestore.Timestamp;
  startISOString: string;
  type: string;
  category: string;
  residentCanSeeGuestList: boolean;
  allDay: boolean | null;

  imageUrl: string;
  thumbnailUrl: string;
  isPublished: boolean;
  scheduledPublishDateTime?: any;
  maxAttendees: string;
  description: string;
  wing?: string;
  wingsIds: string[];
  careLevelId?: string;
  isPaidEvent: boolean;
  cost: number;
  isVirtualEvent: boolean;
  isBroadcast: boolean;
  VideoLink: string;

  attendees: any;
  attendeesIds: Array<string>;
  galleryPhotos: Array<string>;
  images: Array<string>;
  isRecurring: boolean;
  recurringType: RecurringEventsType;
  recurringRepeatType: RecurringRepeatType;
  recurringRepetitions: number;
  recurringRepetitionsDays: Array<string>;
  noEndDate: boolean;
  parentEventId: string;
  conciergeRequestId: string;
  participants: any;
  isExternallyHosted: boolean;
  hostEmailAddress: string;
  duplicatedFrom: string;
  createdByStaffId: string;

  participantLimit?: string;
  participantLimitNumber?: number;
  isWaitingList?: boolean;
  isDisplayInWeekSummary?: boolean;
  isRemoveMembers?: boolean;
  office365EventId?: string;
  office365ResourceEmail?: string;

  constructor() {
    super();
    this.imageUrl = require("../../assets/no-image.jpg");
    this.thumbnailUrl = require("../../assets/no-image.jpg");
    this.name = "";
    this.maxAttendees = "";
    this.location = "";
    this.description = "";
    this.wing = "All";
    this.wingsIds = [];
    this.isPaidEvent = false;
    this.cost = 0;
    this.isVirtualEvent = false;
    this.isBroadcast = false;
    this.start = null;
    this.end = null;
    this.VideoLink = "";
    this.type = null;
    this.invitees = null;
    this.isRecurring = false;
    this.recurringType = RecurringEventsType.Daily;
    this.recurringRepetitionsDays = [];
    this.parentEventId = "";
    this.conciergeRequestId = "";
    this.participants = [];
    this.isExternallyHosted = false;
    this.hostEmailAddress = "";
    this.channelId = "";
    this.galleryPhotos = [];
    this.participantLimit = "";
    this.participantLimitNumber = null;
    this.createdByStaffId = null;
    this.isDisplayInWeekSummary = false;
    this.isRemoveMembers = true;
  }
}
